import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import SmartSearch from '../SmartSearch';
import LayoutMobileMenu from './LayoutMobileMenu';
import CacheStamp from '../CacheStamp';

const LayoutAppBarMobile = ({
  serverConnectionLive,
  serverConnectionTooltip,
  mode,
  toggleMode,
  menuAutoOpen,
  menuAutoOpenToken,
  handleCopyUrl,
  goStory,
  goHome,
  goEnrollmentStatus,
  goSelections,
  goVmtStaging,
  goBulkSend,
  goBuySells,
  goBillingReconciliation,
  goAppsheetAccounts,
  goAppsheetOrderItems,
  goReports,
  handleForceSync,
  handleAbortSync,
  syncSpinning,
  isAbortPending,
  isSyncRequestPending,
  goSettings,
  user,
  logout,
  GoogleDomainSignInButton,
}) => {
  return (
    <>
      <LayoutMobileMenu
        mode={mode}
        toggleMode={toggleMode}
        defaultOpen={menuAutoOpen}
        autoOpenToken={menuAutoOpenToken}
        handleCopyUrl={handleCopyUrl}
        goStory={goStory}
        goHome={goHome}
        goEnrollmentStatus={goEnrollmentStatus}
        goSelections={goSelections}
        goVmtStaging={goVmtStaging}
        goBulkSend={goBulkSend}
        goBuySells={goBuySells}
        goBillingReconciliation={goBillingReconciliation}
        goAppsheetAccounts={goAppsheetAccounts}
        goAppsheetOrderItems={goAppsheetOrderItems}
        goReports={goReports}
        handleForceSync={handleForceSync}
        handleAbortSync={handleAbortSync}
        syncSpinning={syncSpinning}
        isAbortPending={isAbortPending}
        isSyncRequestPending={isSyncRequestPending}
        goSettings={goSettings}
        user={user}
        logout={logout}
        GoogleDomainSignInButton={GoogleDomainSignInButton}
      />
      <Tooltip title={serverConnectionTooltip}>
        <Typography
          variant="subtitle1"
          sx={{
            ml: 0.5,
            mr: 1,
            fontWeight: 600,
            whiteSpace: 'nowrap',
            color: serverConnectionLive ? 'success.light' : 'warning.light',
          }}
        >
          DPE Viewer
        </Typography>
      </Tooltip>
      <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', px: 1 }}>
        <SmartSearch />
      </Box>
      <CacheStamp sx={{ ml: 1 }} />
    </>
  );
};

export default LayoutAppBarMobile;
